import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import AppLayout from '@vf/core/AppLayout';
import AuthRoutes from '@vf/utility/AuthRoutes';
import ContextProvider from '@vf/utility/ContextProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import InfoViewContextProvider from './shared/components/InfoView/InfoViewContext';
import VFThemeProvider from '@vf/utility/VFThemeProvider';
import VFStyleProvider from '@vf/utility/VFStyleProvider';
import ApiContextProvider from '@vf/utility/ApiContextProvider/ApiContextProvider';
import {UserManagementContextProvider, TenantContextProvider} from 'contexts';
import InfoView from 'shared/components/InfoView';
const App = () => (
  <ContextProvider>
    <ApiContextProvider>
      <InfoViewContextProvider>
        <VFThemeProvider>
          <VFStyleProvider>
            <BrowserRouter>
              <InfoView />
              <TenantContextProvider>
                <UserManagementContextProvider>
                  <AuthRoutes>
                    <CssBaseline />
                    <AppLayout />
                  </AuthRoutes>
                </UserManagementContextProvider>
              </TenantContextProvider>
            </BrowserRouter>
          </VFStyleProvider>
        </VFThemeProvider>
      </InfoViewContextProvider>
    </ApiContextProvider>
  </ContextProvider>
);

export default App;
